//region block: pre-declaration
//endregion
function get_contactFullName(_this__u8e3s4) {
  return _this__u8e3s4.g5j_1 + ' ' + _this__u8e3s4.h5j_1;
}
//region block: exports
export {
  get_contactFullName as get_contactFullName2cmbc6sr57lj,
};
//endregion

//# sourceMappingURL=Contractor.ext.shared.mjs.map
